import { create } from 'zustand';

const useIntegratePOSHeartlandRestaurantStore = create((set, get) => ({
  // Heartland-specific form data
  formData: {
    // Prerequisites (Step 0)
    heartlandAccountVerified: false,

    // API Setup (Step 1)
    apiSetupCompleted: false,

    // API Credential Values (Step 2)
    secretKey: '',
  },

  // Current step/page
  currentStep: 0,

  // Total steps for Heartland integration
  totalSteps: 3, // Prerequisites, API Setup, Credential Input

  // Actions
  setFormData: (field, value) => set((state) => ({
    formData: {
      ...state.formData,
      [field]: value,
    },
  })),

  // Step 0: Prerequisites validation
  setHeartlandAccountVerified: (completed) => set((state) => ({
    formData: {
      ...state.formData,
      heartlandAccountVerified: completed,
    },
  })),

  // Step 1: API setup validation
  setAPISetupCompleted: (completed) => set((state) => ({
    formData: {
      ...state.formData,
      apiSetupCompleted: completed,
    },
  })),

  // Navigation
  nextStep: () => set((state) => ({
    currentStep: Math.min(state.currentStep + 1, state.totalSteps - 1),
  })),

  previousStep: () => set((state) => ({
    currentStep: Math.max(state.currentStep - 1, 0),
  })),

  resetForm: () => set(() => ({
    formData: {
      heartlandAccountVerified: false,
      apiSetupCompleted: false,
      secretKey: '',
    },
    currentStep: 0,
  })),

  // Validation helpers
  isStepValid: (step) => {
    const { formData } = get();
    switch (step) {
      case 0: // Prerequisites check
        return formData.heartlandAccountVerified;
      case 1: // API setup
        return formData.apiSetupCompleted;
      case 2: // Credential input
        return formData.secretKey.trim().length > 0;
      default:
        return false;
    }
  },

  // Heartland integration function
  integrateHeartland: async () => {
    try {
      const { formData, resetForm } = get();

      console.log('Heartland integration completed!');

      // Make API call to your backend to save the Heartland credentials
      const response = await fetch('/api/integrations/heartland', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          integrationType: 'api',
          secretKey: formData.secretKey,
          createdAt: new Date().toISOString(),
          version: '1.0'
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to save integration');
      }

      const result = await response.json();

      // Reset the form after successful integration
      resetForm();

      return {
        success: true,
        data: {
          pos: 'heartland',
          integrationType: 'api'
        }
      };

    } catch (error) {
      console.error('Error integrating Heartland:', error);

      return {
        success: false,
        error: error.message || 'Failed to integrate Heartland. Please try again.'
      };
    }
  },
}));

export default useIntegratePOSHeartlandRestaurantStore;
